<p>edit-rent-sidebar works!</p>
